import React, { createContext, useRef } from 'react';

const OptimisticPromiseContext = createContext();

export function OptimisticPromiseProvider({ children }) {
  const promiseMapRef = useRef(new Map());
  
  return (
    <OptimisticPromiseContext.Provider value={promiseMapRef}>
      {children}
    </OptimisticPromiseContext.Provider>
  );
}

export { OptimisticPromiseContext };